import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enUS from '../locales/en-US/common.json';
import svSE from '../locales/sv-SE/common.json';
import fiFI from '../locales/fi-FI/common.json';
import nbNO from '../locales/nb-NO/common.json';
import daDK from '../locales/da-DK/common.json';
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from './languages';

const resources = {
  'en-US': { common: enUS },
  'sv-SE': { common: svSE },
  'fi-FI': { common: fiFI },
  'nb-NO': { common: nbNO },
  'da-DK': { common: daDK },
};

if (!i18n.isInitialized) {
  i18n
    .use(initReactI18next)
    .init({
      resources,
      lng: DEFAULT_LANGUAGE,
      fallbackLng: DEFAULT_LANGUAGE,
      supportedLngs: SUPPORTED_LANGUAGES as unknown as string[],
      ns: ['common'],
      defaultNS: 'common',
      interpolation: {
        escapeValue: false,
      },
      returnNull: false,
      returnEmptyString: false,
    })
    .catch((error) => {
      console.error('Failed to initialize i18n', error);
    });
}

export default i18n;
